import React from 'react';
import { useQuery } from 'react-query';
import { Get } from '../../../../utils/httpProvider';
import { ACCOUNT_AUTHINFO_API } from '../../../../utils/apiUrl';

/**
 * Component chuyên biệt hiển thị thông tin Học viên trong danh sách CME
 * Sử dụng phối hợp 2 API từ cổng 5003 để lấy đầy đủ thông tin
 */
const CMEParticipantCell = ({ userId, mode }) => {
    // 1. Lấy thông tin cơ bản (Họ tên) bằng ID (API này luôn hỗ trợ ID)
    const { data: authInfo, isLoading: loadingAuthInfo } = useQuery(
        ['authInfoBasic', userId],
        () => Get(ACCOUNT_AUTHINFO_API.GET_BY_ID_ACCOUNT, userId),
        {
            enabled: !!userId,
            staleTime: 600000,
            cacheTime: 900000
        }
    );

    const fullName = [
        authInfo?.lastName || authInfo?.LastName,
        authInfo?.middleName || authInfo?.MiddleName,
        authInfo?.firstName || authInfo?.FirstName
    ].filter(Boolean).join(' ') || '';

    // 2. Dùng Họ tên vừa lấy được để tìm Username (CCCD) qua GET_PAGING (Vì API 1 không có Username)
    const { data: searchRes, isLoading: loadingSearch } = useQuery(
        ['authInfoSearchName', fullName],
        () => Get(`${ACCOUNT_AUTHINFO_API.GET_PAGING}?Keyword=${fullName}&PageIndex=1&PageSize=10`),
        {
            enabled: !!fullName && mode === 'username',
            staleTime: 600000,
            cacheTime: 900000
        }
    );

    if (!userId) return <span className="text-muted">N/A</span>;
    
    if (loadingAuthInfo || (loadingSearch && mode === 'username')) {
        return (
            <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                <small className="text-muted" style={{ fontSize: '0.8rem' }}>...</small>
            </div>
        );
    }

    // Tìm đúng người trong danh sách kết quả dựa trên ID
    const matchedUser = (searchRes?.data || searchRes?.items || searchRes?.$values || [])
        .find(u => (u.accountId || u.AccountId || u.id) === userId);

    const uName = matchedUser?.userName || matchedUser?.UserName || matchedUser?.account?.username;

    if (mode === 'username') return <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{uName || 'N/A'}</span>;
    if (mode === 'name') return <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName || 'Chưa cập nhật'}</span>;

    return (
        <div className="d-flex flex-column">
            <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName || 'Chưa cập nhật'}</span>
            {uName && <small className="text-muted" style={{ fontSize: '0.75rem' }}>{uName}</small>}
        </div>
    );
};

export default CMEParticipantCell;
